import Api from '../baseApi';

export default {
  async validate(model) {
    return await Api.patch('/api-article/v1/articleDefinition', model);
  },
  async create(model) {
    return await Api.put('/api-article/v1/articleDefinition', model);
  },
  async fetch(id) {
    return await Api.get('/api-article/v1/articleDefinition/' + id);
  }
}
